export default __webpack_public_path__ + "static/media/Twist-footer-logo-3-2023.2d2a6afa.png";